export default "__VITE_ASSET__ChWgs$AX__"